import { openExternalUrl } from "@/lib/open-url";
import { emitTerminalTelemetry } from "@/lib/terminal-telemetry";

export type LinkRoutingResult = "external" | "ignored";

/**
 * Centralized link routing policy for chat/terminal surfaces.
 * All links open externally.
 */
export function routeChatLink(url: string): LinkRoutingResult {
  const normalizedUrl = url.trim();
  if (!normalizedUrl) return "ignored";
  const telemetryLink = buildLinkTelemetryPayload(normalizedUrl);

  openExternalUrl(normalizedUrl);
  emitTerminalTelemetry("agent_link_opened_external", telemetryLink);
  return "external";
}

function buildLinkTelemetryPayload(url: string): Record<string, unknown> {
  try {
    const parsed = new URL(url);
    return {
      host: parsed.hostname,
      path: parsed.pathname,
    };
  } catch {
    return { host: "invalid", path: "" };
  }
}
